import ROUTE_PATH from 'routes/config';
const { login, mypage } = ROUTE_PATH;

export const modalMessages = {
  [login.joinMember]: '회원가입을 중단하시겠어요?',
  [mypage.updateBusiness]: '사업자정보 확인을 중단하시겠어요?',
  [mypage.checkLoan]: '대출 비교를 중단하시겠어요?',
  // [mypage.dataLinkageRequest]: '데이터 연동을 중단하시겠어요?', // TODO: 원래는 데이터 연동 등록 페이지에서 뒤로 가기 클릭시 메세지 떴는데, 기획 변경됐는지 질문하기
};
